import { POLL_INTERVAL_MS } from 'constants/defaults'
import { selectMarketName, selectNetwork, selectWallet } from 'state/app/selectors'
import { useAppSelector, useFetchAction, usePollAction } from 'state/hooks'
import { fetchPreviousDayPrices } from 'state/prices/actions'
import { selectCurrentMarketPrice } from 'state/prices/selectors'
import { fetchBalance } from 'state/wallet/actions'
import { fetchDailyVolumes, fetchLiquidityBook, fetchMarkets, fetchOpenOrders, fetchOrderbook } from "./actions"
import { selectCurrentMarketAsset } from './selectors'

export const useFetchExchangeData = () => {
	const wallet = useAppSelector(selectWallet)
	const network = useAppSelector(selectNetwork)
	const curMarketName = useAppSelector(selectMarketName)

	usePollAction('fetchDailyVolumes', fetchDailyVolumes, {
		dependencies: [network],
		intervalTime: POLL_INTERVAL_MS,
		disabled: curMarketName === undefined || network === undefined,
	})
	useFetchAction(fetchPreviousDayPrices, {
		dependencies: [network, curMarketName],
		disabled: curMarketName === undefined || network === undefined,
	})
}

export const useFetchMarketData = () => {
	const wallet = useAppSelector(selectWallet)
	const network = useAppSelector(selectNetwork)
	const curMarketName = useAppSelector(selectMarketName)
	const curPrice = useAppSelector(selectCurrentMarketPrice)
	const currentPair = useAppSelector(selectCurrentMarketAsset)

	usePollAction('fetchOrderbook', fetchOrderbook, {
		dependencies: [network, curMarketName, currentPair],
		intervalTime: POLL_INTERVAL_MS,
		disabled: curMarketName === undefined || curPrice === undefined,
	})

	usePollAction('fetchLiquidityBook', fetchLiquidityBook, {
		dependencies: [network, curMarketName, currentPair],
		intervalTime: POLL_INTERVAL_MS,
		disabled: curMarketName === undefined || curPrice === undefined,
	})

	useFetchAction(fetchOpenOrders, {
		dependencies: [network, curMarketName],
		disabled: curMarketName === undefined || network === undefined || wallet === null,
	})
}

